import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Grid, Row } from 'react-bootstrap';
import { actions } from 'react-redux-form';
import PageTitle from '../../common/page-title';
import { getTeamOutlet } from '../../../actions/outlet';
import OutletDetails from '../../common/outlet/outlet-details';
import Divider from '../../common/divider';
import StaffMemberList from '../../common/outlet/staff-member-list';
import TeamRewardDetails from './team-reward-details';
import StorePerformance from './store-performance';
import ArrowButton from '../../common/button-arrow';
import { doPseudoLoginRep } from '../../../actions/users';
import { sendStoreMessage } from '../../../actions/messages';
import MessageDialog from '../my-stores/message-dialog';
import Can from '../../common/guards/can';
import { history } from '../../../store';

import './style.css';

class StoreDetails extends Component {
  state = {
    showMessageDialog: false
  };

  handleStoreDemoClick = (userId) => {
    const { dispatch } = this.props;

    dispatch(doPseudoLoginRep(userId))
      .then(() => {
        setTimeout(() => {
          localStorage.setItem('rep-pseudo-login-started-from', window.location.href);
          window.location.href = '/';
        }, 2000);
      });
  };

  openMessageModal = () => {
    try {
      this.setState({
        showMessageDialog: true
      }, () => {
        this.props.dispatch(actions.reset('deep.store_message'));
      });
    } catch (error) { //
      // swallowed modal lib bug error
    }
  };

  handleMessageClose = () => {
    this.setState({
      showMessageDialog: false
    });
  };

  handleMessageSend = (payload) => {
    const { dispatch, store } = this.props;

    const message = {
      ...payload,
      outlet_id: store.id,
    };

    dispatch(sendStoreMessage(message))
      .then(() => {
        dispatch(actions.reset('deep.store_message'));
        this.handleMessageClose();
      });
  };

  componentWillMount() {
    const { dispatch, match } = this.props;

    dispatch(getTeamOutlet(match.params.id));
  }

  render() {
    const { fetched, store, staffMembers } = this.props;
    const { showMessageDialog } = this.state;

    return (fetched && (
      <Grid bsClass="container" fluid className="details">
        <Row>
          <Col lg={12}>
            <Button bsStyle='link' className='back-link' onClick={() => history.goBack()}>
              Back
            </Button>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PageTitle>
              View Outlet
            </PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {store.attributes.owner.id && (
              <ArrowButton
                className="float-right"
                arrow={false}
                submit={false}
                onClick={() => this.handleStoreDemoClick(store.attributes.owner.id)}
              >
                Store Demo
              </ArrowButton>
            )}
            <h3>
              Outlet details
            </h3>
            <OutletDetails id={store.id} details={store.attributes}/>
            <Can action="view" subjectClass="messages_rep_area">
              {store.attributes.owner.id && (
                <ArrowButton
                  arrow={false}
                  submit={false}
                  onClick={() => this.openMessageModal()}
                >
                  Send a message
                </ArrowButton>
             )}
            </Can>
            <Divider/>
          </Col>
        </Row>
        <Can action="show" subjectClass="rewards_details_rep_area">
          {store.attributes['reward-store'] && (
            <Row>
              <Col lg={12}>
                <h3>
                  Reward details
                </h3>
                <TeamRewardDetails store={store}/>
                <Divider/>
              </Col>
            </Row>
          )}
        </Can>
        {store.attributes['reward-store'] && (
          <Row>
            <Col lg={12}>
              <h3>
                Store performance
              </h3>
              <StorePerformance outletId={store.id}/>
              <Divider/>
            </Col>
          </Row>
        )}
        <Can action="view" subjectClass="staff_rep_area">
          <Row>
            <Col lg={12}>
              <h3>
                Staff details
              </h3>
              <StaffMemberList
                owner={store.attributes.owner}
                staffMembers={staffMembers}
              />
            </Col>
          </Row>
        </Can>
        {showMessageDialog && (
          <MessageDialog
            onClose={this.handleMessageClose}
            onMessageSend={payLoad => this.handleMessageSend(payLoad)}
            to={`${store.attributes.owner.name}-${store.attributes.name}-${store.id}`}
          />
        )}
      </Grid>
    ));
  }
}

const mapStateToProps = state => ({
  store: state.teamStoreDetail.store,
  staffMembers: state.teamStoreDetail.staff_members,
  fetching: state.teamStoreDetail.fetching,
  fetched: state.teamStoreDetail.fetched,
});

export default connect(mapStateToProps)(StoreDetails);



// WEBPACK FOOTER //
// ./src/components/team/store-details/index.jsx